var _line, _line2, _line3, _path, _circle, _circle2, _circle3, _circle4, _circle5, _path2, _circle6, _circle7, _circle8, _circle9, _circle0, _path3, _circle1, _circle10, _circle11, _circle12, _circle13, _path4, _circle14, _circle15, _circle16, _circle17, _circle18, _path5, _circle19, _circle20, _circle21, _circle22, _circle23, _path6, _circle24, _circle25, _circle26, _circle27, _circle28, _path7, _circle29, _circle30, _circle31, _circle32, _circle33;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExt3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 153,
    viewBox: "0 0 153 153",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 120.093,
    y1: 52.4651,
    x2: 35.0582,
    y2: 101.272,
    stroke: "#C8C4C0",
    strokeOpacity: 0.21,
    strokeWidth: 4
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 117.08,
    y1: 101.766,
    x2: 33.0508,
    y2: 52.4557,
    stroke: "#C8C4C0",
    strokeOpacity: 0.21,
    strokeWidth: 4
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 75.3359,
    y1: 124.193,
    x2: 75.3359,
    y2: 29.0949,
    stroke: "#C8C4C0",
    strokeOpacity: 0.21,
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.8309 65.5381H39.7421C42.4101 65.5381 44.573 63.3752 44.573 60.7072V57.5984C44.573 56.6085 44.2754 55.6372 43.5939 54.9194C42.0685 53.3126 38.8183 50.6055 34.251 50.6291C29.6915 50.6525 26.4796 53.3314 24.9717 54.9236C24.2945 55.6387 24 56.6055 24 57.5904V60.7072C24 63.3752 26.1629 65.5381 28.8309 65.5381Z",
    fill: "#F09E80"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 34.2862,
    cy: 43.8409,
    r: 8.20419,
    fill: "#F09E80"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.288,
    cy: 42.7587,
    r: 2.12393,
    fill: "#F1F1F1"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.288,
    cy: 42.7587,
    r: 2.12393,
    fill: "#F1F1F1"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 38.0341,
    cy: 42.7587,
    r: 2.12393,
    fill: "#F1F1F1"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 38.0341,
    cy: 42.7587,
    r: 2.12393,
    fill: "#F1F1F1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0907 43.9013H81.0018C83.6699 43.9013 85.8327 41.7385 85.8327 39.0704V35.9616C85.8327 34.9718 85.5352 34.0005 84.8537 33.2826C83.3283 31.6759 80.078 28.9688 75.5108 28.9923C70.9513 29.0158 67.7393 31.6947 66.2315 33.2869C65.5543 34.002 65.2598 34.9688 65.2598 35.9536V39.0704C65.2598 41.7385 67.4226 43.9013 70.0907 43.9013Z",
    fill: "#F09E80"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 75.546,
    cy: 22.2042,
    r: 8.20419,
    fill: "#F09E80"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 71.5478,
    cy: 21.122,
    r: 2.12393,
    fill: "#F1F1F1"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 71.5478,
    cy: 21.122,
    r: 2.12393,
    fill: "#F1F1F1"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 79.2939,
    cy: 21.122,
    r: 2.12393,
    fill: "#F1F1F1"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 79.2939,
    cy: 21.122,
    r: 2.12393,
    fill: "#F1F1F1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M113.866 65.5381H124.777C127.445 65.5381 129.608 63.3752 129.608 60.7072V57.5984C129.608 56.6085 129.311 55.6372 128.629 54.9194C127.104 53.3126 123.853 50.6055 119.286 50.6291C114.727 50.6525 111.515 53.3314 110.007 54.9236C109.33 55.6387 109.035 56.6055 109.035 57.5904V60.7072C109.035 63.3752 111.198 65.5381 113.866 65.5381Z",
    fill: "#F09E80"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 119.321,
    cy: 43.8409,
    r: 8.20419,
    fill: "#F09E80"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 115.323,
    cy: 42.7587,
    r: 2.12393,
    fill: "#F1F1F1"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 115.323,
    cy: 42.7587,
    r: 2.12393,
    fill: "#F1F1F1"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 123.069,
    cy: 42.7587,
    r: 2.12393,
    fill: "#F1F1F1"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 123.069,
    cy: 42.7587,
    r: 2.12393,
    fill: "#F1F1F1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8309 114.849H39.7421C42.4101 114.849 44.573 112.686 44.573 110.018V106.909C44.573 105.919 44.2754 104.948 43.5939 104.23C42.0685 102.623 38.8183 99.9161 34.251 99.9396C29.6915 99.9631 26.4796 102.642 24.9717 104.234C24.2945 104.949 24 105.916 24 106.901V110.018C24 112.686 26.1629 114.849 28.8309 114.849Z",
    fill: "#F09E80"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.2862,
    cy: 93.1515,
    r: 8.20419,
    fill: "#F09E80"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.288,
    cy: 92.0692,
    r: 2.12393,
    fill: "#F1F1F1"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.288,
    cy: 92.0692,
    r: 2.12393,
    fill: "#F1F1F1"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 38.0341,
    cy: 92.0692,
    r: 2.12393,
    fill: "#F1F1F1"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 38.0341,
    cy: 92.0692,
    r: 2.12393,
    fill: "#F1F1F1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1043 138.999H81.0155C83.6835 138.999 85.8464 136.836 85.8464 134.168V131.059C85.8464 130.069 85.5488 129.098 84.8673 128.38C83.3419 126.774 80.0917 124.066 75.5244 124.09C70.9649 124.113 67.753 126.792 66.2452 128.385C65.568 129.1 65.2734 130.066 65.2734 131.051V134.168C65.2734 136.836 67.4363 138.999 70.1043 138.999Z",
    fill: "#F09E80"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 75.5597,
    cy: 117.302,
    r: 8.20419,
    fill: "#F09E80"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 71.5614,
    cy: 116.22,
    r: 2.12393,
    fill: "#F1F1F1"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 71.5614,
    cy: 116.22,
    r: 2.12393,
    fill: "#F1F1F1"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 79.3075,
    cy: 116.22,
    r: 2.12393,
    fill: "#F1F1F1"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 79.3075,
    cy: 116.22,
    r: 2.12393,
    fill: "#F1F1F1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1043 91.0693H81.0155C83.6835 91.0693 85.8464 88.9064 85.8464 86.2384V83.1296C85.8464 82.1398 85.5488 81.1684 84.8673 80.4506C83.3419 78.8439 80.0917 76.1368 75.5244 76.1603C70.9649 76.1838 67.753 78.8626 66.2452 80.4549C65.568 81.17 65.2734 82.1368 65.2734 83.1216V86.2384C65.2734 88.9064 67.4363 91.0693 70.1043 91.0693Z",
    fill: "#C24848"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 75.5597,
    cy: 69.3722,
    r: 8.20419,
    fill: "#C24848"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 71.5614,
    cy: 68.2899,
    r: 2.12393,
    fill: "#F1F1F1"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 71.5614,
    cy: 68.2899,
    r: 2.12393,
    fill: "#F1F1F1"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 79.3075,
    cy: 68.2899,
    r: 2.12393,
    fill: "#F1F1F1"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 79.3075,
    cy: 68.2899,
    r: 2.12393,
    fill: "#F1F1F1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M113.866 114.849H124.777C127.445 114.849 129.608 112.686 129.608 110.018V106.909C129.608 105.919 129.311 104.948 128.629 104.23C127.104 102.623 123.853 99.9161 119.286 99.9396C114.727 99.9631 111.515 102.642 110.007 104.234C109.33 104.949 109.035 105.916 109.035 106.901V110.018C109.035 112.686 111.198 114.849 113.866 114.849Z",
    fill: "#F09E80"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 119.321,
    cy: 93.1515,
    r: 8.20419,
    fill: "#F09E80"
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 115.323,
    cy: 92.0692,
    r: 2.12393,
    fill: "#F1F1F1"
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: 115.323,
    cy: 92.0692,
    r: 2.12393,
    fill: "#F1F1F1"
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: 123.069,
    cy: 92.0692,
    r: 2.12393,
    fill: "#F1F1F1"
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: 123.069,
    cy: 92.0692,
    r: 2.12393,
    fill: "#F1F1F1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExt3);
export default __webpack_public_path__ + "static/media/ext-3.1430716763c21f328e202a0bab7ba588.svg";
export { ForwardRef as ReactComponent };